import * as THREE from "three";
import constraints from "./constraints.js";
import Wc from "../Wc.js";
import WashBasin from "../WashBasin.js";
import ShowerTray from "../ShowerObjects/ShowerTray.js";
import ShowerFaucet from "../ShowerObjects/ShowerFaucet.js";
import ShowerGrabBar from "../ShowerObjects/ShowerGrabBar.js";
import ShowerSeat from "../ShowerObjects/ShowerSeat.js";
import ShowerWall from "../ShowerObjects/ShowerWall.js";
import Furniture from "../Furniture.js";
import Partition from "../Partition.js";
import PipeBoxing from "../PipeBoxing.js";
import Radiator from "../Radiator.js";
import ShowerPanel from "../ShowerObjects/ShowerPanel.js";
import Mirror from "../Mirror.js";
import Door from "../Door.js";
import Window from "../Window.js";
import Experience from "../../../Experience.js";

/**
 * Class for add, remove, replace, get objects in the room
 */
export default class ObjectManager {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.room = null;
    this.objectsInScene = [];
    this.objectsCollisionInScene = [];
    this.constraints = constraints;

    this.objectsSaveScene = [];
    this.instanceObjects = [];

    this.typesCreatedObjects = [];
  }

  /**
   * Set Room when Room is initialized
   */
  setRoom(room) {
    this.room = room;
  }

  /**
   * Add objet in array cart
   */
  addObject(object) {
    
    this.objectsInScene.push(object);

    

    
  }

  /**
   * Add object in array for colllision
   */
  addObjectCollision(object) {
    this.objectsCollisionInScene.push(object);
  }

  removeObjectCollision(object) {
    const index = this.objectsCollisionInScene.indexOf(object);
    if (index !== -1) {
      this.objectsCollisionInScene.splice(index, 1); // Supprime l'élément à l'index trouvé
    }
  }

  // Delete instance of object
  removeInstanceObject(object) {
    const indexInstance = this.instanceObjects.indexOf(
      this.getInstanceByObject(object)
    );
    if (indexInstance > -1) {
      this.instanceObjects.splice(indexInstance, 1);
    }
  }

  /**
   * Remove object in array cart
   */
  removeObject(object) {
    // Delete the object in the scene
    
    const index = this.objectsInScene.indexOf(object);
    if (index > -1) {
      this.objectsInScene.splice(index, 1);
    }


    // Delete type in typesCreatedObjects
    const typeIndex = this.typesCreatedObjects.indexOf(object.userData.type);
    if (typeIndex > -1) {
      this.typesCreatedObjects.splice(typeIndex, 1);
      console.log(
        `Objet "${
          object.userData.type
        }" supprimé. Total : ${this.getCountByType(object.userData.type)}`
      );
    } else {
      console.warn(
        `Aucun objet de type "${object.userData.type}" trouvé à supprimer.`
      );
    }

    this.removeObjectCollision(object);
    this.removeInstanceObject(object);
    
  }

  /**
   * Get objects in cart
   */
  getObjects() {
    return this.objectsInScene;
  }

  /**
   * Get objects collision
   */
  getObjectsCollision() {
    return this.objectsCollisionInScene;
  }

  /**
   * Get info objects for JSON
   */
  getSaveInfosObjects() {
    this.objectsSaveScene = [];
    
    // Parcourt tous les enfants de la scène
    this.scene.traverse((object) => {
      
      
      // Vérifie si l'objet contient les données nécessaires dans `userData`
      if (object.userData && object.userData.type && object.name !== "floor") {
        
        this.objectsSaveScene.push({
          type: object.userData.type, // Type d'objet
          id: object.userData.id, // ID de l'objet
          texture: object.userData.texture, // Texture associée
          src: object.userData.src, // Source de l'objet (le modèle ou autre)
          subType: object.userData.subType || null,
          scale: object.userData.scale, // Échelle de l'objet
          position: object.name === "window" ? object.parent.position.clone() : object.position.clone(), // Position de l'objet
          rotation: object.name === "window" ? object.parent.rotation.clone() : object.rotation.clone(), // Rotation de l'objet
        });
      }
    });
  
    // Retourne les informations sauvegardées
    return this.objectsSaveScene;
  }

  /**
   * Get number of a type of object in the scene
   */
  getCountByType(type) {
    return this.typesCreatedObjects.filter(
      (createdType) => createdType === type
    ).length;
  }

  /**
   * Check if object can be create (or not > numberMax)
   */
  canCreate(type) {
    const currentCount = this.getCountByType(type);
    const maxAllowed = this.constraints[type]?.numberMax || Infinity;

    if (currentCount < maxAllowed) {
      return true;
    } else {
      console.warn(`Limite atteinte pour le type "${type}".`);
      return false;
    }
  }

  /**
   * Replace object
   */

  replaceObject(type, options = {}) {
    // Trouve tous les objets du même type
    
    const existingObjects = this.findObjectsByType(type);

    // Limite maximale d'objets autorisés
    const maxAllowed = this.constraints[type]?.numberMax || Infinity;

    
    // Si un seul objet de ce type est autorisé, remplace automatiquement
    if (existingObjects.length === 1 && maxAllowed === 1) {

      
      
      existingObjects[0].setModel(options);
      return existingObjects[0];
    }

    // Si plusieurs objets sont autorisés, vérifie l'objet sélectionné
    if (existingObjects.length > 0 && maxAllowed > 1) {
      
      const selectedObject = this.room.getSelectedObject();
      
      if (selectedObject) {
        // Vérifie si l'objet sélectionné fait partie des objets trouvés
        const selectedInstance = this.getInstanceByObjectForReplace(selectedObject);
        
        if (selectedInstance && selectedObject.userData.type === type) {

          selectedInstance.setModel(options);
          return selectedInstance;
        } else {
          console.error("L'objet sélectionné ne correspond pas au type.");
          return null;
        }
      } else {
        alert("Aucun objet sélectionné");
        return null;
      }
    }

    console.error("Aucun objet à remplacer.");
    return null;
  }

  /**
   * create object
   */

  createObject(type, options = {}) {
    
    if (!this.canCreate(type)) {
      alert(
        "Vous avez atteint le nombre maximum de cet objet dans cette salle."
      );
      return;
    }

    // Creates a new object if no existing object was found
    let newObject;

    switch (type) {
      case "wc":
      case "washBasin":
      case "mirror":
      case "door":
      case "furniture":
      case "showerTray":
      case "showerGrabBar":
      case "showerSeat":
      case "showerFaucet":
      case "window":
      case "showerWall":
      case "radiator":
        newObject = this.createFurnitureLikeObject(type, options);
        break;

      case "partition":
      case "pipeBoxing":
      case "showerPanel":
        newObject = this.createPanelLikeObject(type, options);
        break;

      default:
        console.error(`Type d'objet inconnu : ${type}`);
        return null;
    }

    if (newObject) {
      this.typesCreatedObjects.push(type);
      this.instanceObjects.push(newObject);
    }
    return newObject;
  }

  /**
   * Create objects like furniture (with glb model)
   */
  createFurnitureLikeObject(
    type,
    {
      modelPath,
      id,
      position = new THREE.Vector3(0, 0, 0),
      rotation = new THREE.Euler(0,0,0),
      scale = new THREE.Vector3(1,1,1),
      pn, // for showerTray
      subType, // for showerWall
      aimantee, // for showerWall
      rideauLeste // for showerWall
    }
  ) {
    if (!modelPath) {
      console.error(
        `Les paramètres "modelPath" et "position" sont obligatoires pour "${type}".`
      );
      return null;
    }

    let object;

    switch (type) {
      case "wc":
        object = new Wc(modelPath, id, position, rotation);
        break;
      case "washBasin":
        object = new WashBasin(modelPath, id, position, rotation);
        break;
      case "furniture":
        object = new Furniture(modelPath, id, position, rotation);
        break;
      case "showerTray":
        object = new ShowerTray(modelPath, id, position, scale, pn, rotation);
        break;
      case "showerWall":
        object = new ShowerWall(modelPath, id, position, scale, subType, rotation, aimantee, rideauLeste);
        break;
      case "showerGrabBar":
        object = new ShowerGrabBar(modelPath, id, position, rotation);
        break;
      case "showerSeat":
        object = new ShowerSeat(modelPath, id, position, rotation);
        break;
      case "showerFaucet":
        object = new ShowerFaucet(modelPath, id, position, rotation, subType);
        break;
      case "mirror":
        object = new Mirror(modelPath, id, position, rotation);
        break;
      case "door":
        object = new Door(modelPath, id, position, rotation);
        break;
      case "window":
        object = new Window(modelPath, id, position, scale, rotation);
        break;
      case "radiator":
        object = new Radiator(modelPath, id, position, rotation);
        break;
    }

    return object;
  }

  /**
   * Create objects with geometry box
   */
  createPanelLikeObject(type, { scale, position, srcTexture, subType, rotation }) {
    let object;

    switch (type) {
      case "partition":
        object = new Partition(scale, position, srcTexture, rotation);
        break;
      case "pipeBoxing":
        object = new PipeBoxing(scale, position, srcTexture, rotation);
        break;
      case "showerPanel":
        object = new ShowerPanel(scale, position, srcTexture, subType, rotation);
        break;
    }

    return object;
  }

  /**
   * Get object by userData
   */
  findObjectsByType(type) {
   
    if (this.getObjects().length > 0) {
      const foundObjects = this.getObjects().filter(
        (obj) => obj.userData.type === type
      );

      
      if (foundObjects.length > 0) {
        return foundObjects.map((object) => this.getInstanceByObjectForReplace(object));
      }
    }
    return [];
  }

  /* findObjectsByType(type) {
    console.log(this.getObjects().length);
    
    if (this.getObjects().length > 0) {
      const found = this.getObjects().find((obj) => obj.userData.type === type);

      if (found) {
        return this.getInstanceByObject(found);
      }
      return null;
    } else {
      return null;
    }
  } */

  /**
   * Get instance by object for replace
   */
  getInstanceByObjectForReplace(object) {
    return this.instanceObjects.find((instance) => instance.model === object);
  }

  /**
   * Get instance of an object
   */
  getInstanceByObject(object) {
    // Vérifie si l'object est directement un mesh
    let targetObject = object;

    // Parcourt la hiérarchie pour trouver le Mesh
    if(!targetObject instanceof THREE.Mesh) {
      targetObject = targetObject.children[0]
    }
    while (targetObject && !(targetObject instanceof THREE.Mesh)) {
      targetObject = targetObject.children;
    }
    
    // Cherche l'instance correspondante dans instanceObjects
    return this.instanceObjects.find(
      (instance) => instance.mesh === targetObject
    );
  }

  /**
   * Duplicate instance of an object
   */
  cloneInstance(object) {
    const instance = this.getInstanceByObject(object);
    
    if (!instance) {
      console.error("Aucune instance trouvée pour cet objet :", object);
      return;
    }
  
    // Utilise la méthode de clonage personnalisée
    const clonedInstance = instance.cloneInstance();
  
    // Ajoute l'objet cloné dans la liste des instances
    this.instanceObjects.push(clonedInstance);
  
  
    return clonedInstance.mesh; // Retourne le Mesh cloné
  }
}  
